import {useMutation} from "@apollo/client";
import {
    CreateServiceInterviewDocument,
    CreateServiceInterviewMutationResult,
    CreateServiceInterviewMutationVariables
} from "~/queries";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useCallback, useEffect} from "react";
import {tuple} from "~/types";


export function useCreateServiceInterview() {
    const handleError = useErrorHandler();
    const [mutate, {error, called, loading}] = useMutation<CreateServiceInterviewMutationResult, CreateServiceInterviewMutationVariables>(CreateServiceInterviewDocument, {
        notifyOnNetworkStatusChange: true,
    });

    const create = useCallback((data: CreateServiceInterviewMutationVariables["serviceInterview"]) => {
        mutate({
            variables: {
                serviceInterview: data
            }
        }).catch(console.error);
    }, []);

    useEffect(() => {
        if (error) {
            handleError(error);
        }
    }, [error])

    return tuple(create, {
        loading: loading,
        error: error,
        called: called,
        completed: called && !error && !loading,
    });
}